import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Line } from "react-chartjs-2";
import ReactApexChart from "react-apexcharts";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import CountUp from "react-countup";
import DashBoardServices from "../../Services/QRCodeServices/DashBoardServices/DashBoardServices";
import PaymentDistributionChart from "../DashboardComponents/PaymentDistributionChart";
import {
  topCustomers,
  topProducts,
} from "../../QRCodeCustomerPanel/Theme/DigitalMenuAI/Component/StaticData";
import ProfileDashboard from "../ProfileDashboard";
import TopCustomerModal from "../DashboardComponents/TopCustomerModal";
import TopSellingProductModal from "../DashboardComponents/TopSellingProductModal";
import OrganizationService from "../../Services/QRCodeServices/OrganizationManagement/OrganizationService";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default function OrgDashboard() {
  const [data, setData] = useState([]);
  const [dashboardData, setDashboardData] = useState([]);
  const [paymentData, setPaymentData] = useState([]);
  const [productData, setProductData] = useState([]);

  const user = JSON.parse(localStorage.getItem("user"));
  const orgId = user?.organizationInfo?.id || "";
  const role = user?.user?.roles[0] || "";
  // const hasOMS = user?.organizationInfo?.hasOMS || false;

  const [modalOpen, setModalOpen] = useState(false);
  const [sellingProductModalOpen, setSellingProductModalOpen] = useState(false);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };
  const toggleSellingProductModal = () => {
    setSellingProductModalOpen(!sellingProductModalOpen);
  };

  // Bar chart configuration
  const barChartOptions = {
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    title: {
      text: "Monthly Sales Overview",
      align: "left",
    },
    xaxis: {
      categories: ["Jan", "Feb", "Mar"],
    },
    yaxis: {
      title: {
        text: "$ (thousands)",
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return "$ " + val + " thousands";
        },
      },
    },
  };

  const barChartSeries = [
    {
      name: "Net Profit",
      data: [44, 55, 57],
    },
    {
      name: "Revenue",
      data: [76, 85, 101],
    },
  ];

  // Non-OMS stats
  const [nonOmsStats, setNonOmsStats] = useState({
    totalCategories: 20,
    totalProducts: 200,
    totalVisitors: 333,
  });

  const fetchAllData = async () => {
    try {
      const orgResponse = await OrganizationService.detail(orgId);
      setData(orgResponse);

      const dashboardResponse = await DashBoardServices.getDashboardList();
      setDashboardData(dashboardResponse);

      const paymentResponse = await DashBoardServices.getPaymentList();
      setPaymentData(paymentResponse);

      const productResponse = await DashBoardServices.getProductData();
      setProductData(productResponse);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row className="mt-3">
            {role !== "SuperAdmin" && (
              <Col lg={12}>
                <p className="mb-2 fs-5 fw-semibold d-print-none">Profile</p>
                <Card className="p-2 rounded-3 mb-2">
                  <ProfileDashboard data={data} />
                </Card>
              </Col>
            )}

            {role !== "SuperAdmin" && (
              <Row lg={12} className="mt-4">
                <Row className="g-3 p-0 m-0">
                  <Col lg={4} md={6} sm={12}>
                    <Card
                      className="card-animate cursor-pointer bg-info"
                      style={{ height: "130px" }}
                    >
                      <CardBody>
                        <div className="d-flex align-items-center">
                          <div className="flex-grow1 overflow-hidden">
                            <p className="text-uppercase fw-bold text-white-50 text-truncate mb-0 text-decoration-underline">
                              Total Sales Count
                            </p>
                          </div>
                        </div>
                        <div className="d-flex align-items-end justify-content-between mt-4">
                          <div>
                            <h4 className="fs-22 fw-bold ff-secondary mb-2 text-white">
                              <span>
                                <CountUp
                                  start={0}
                                  end={dashboardData.itemSalesCount}
                                  duration={2.5}
                                  separator=","
                                  prefix=""
                                />
                              </span>
                            </h4>
                            <p className="text-white-50 mb-0">
                              Sales NRS.
                              <CountUp
                                start={0}
                                end={dashboardData.totalSales}
                                duration={2.5}
                                separator=","
                                decimals={2}
                              />
                            </p>
                          </div>
                          <div className="avatar-sm flex-shrink-0">
                            <span
                              className={`avatar-title bg-white bg-opacity-10 rounded fs-3`}
                            >
                              <i
                                className={`text-white bx bx-dollar-circle`}
                              ></i>
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  {/* Replace the existing KOT and BOT cards with these updated versions */}
                  <Col lg={4} md={6} sm={12}>
                    <Card
                      className="card-animate cursor-pointer bg-secondary"
                      style={{ height: "130px" }}
                    >
                      <CardBody>
                        <div className="d-flex align-items-center">
                          <div className="flex-grow1 overflow-hidden">
                            <p className="text-uppercase fw-bold text-white-50 text-truncate mb-0 text-decoration-underline">
                              Total KOT
                            </p>
                          </div>
                        </div>
                        <div className="d-flex align-items-end justify-content-between mt-4">
                          <div>
                            <h4 className="fs-22 fw-bold ff-secondary mb-2 text-white">
                              <span>
                                <CountUp
                                  start={0}
                                  end={dashboardData.kotCount}
                                  duration={2.5}
                                  separator=","
                                />
                              </span>
                            </h4>
                            <p className="text-white-50 mb-0">
                              Sales NRS.
                              <CountUp
                                start={0}
                                end={dashboardData.kotSalesAmount}
                                duration={2.5}
                                separator=","
                                decimals={2}
                              />
                            </p>
                          </div>
                          <div className="avatar-sm flex-shrink-0">
                            <span
                              className={`avatar-title bg-white bg-opacity-10 rounded fs-3`}
                            >
                              <i
                                className={`text-white bx bx-shopping-bag`}
                              ></i>
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg={4} md={6} sm={12}>
                    <Card
                      className="card-animate cursor-pointer bg-success"
                      style={{ height: "130px" }}
                    >
                      <CardBody>
                        <div className="d-flex align-items-center">
                          <div className="flex-grow1 overflow-hidden">
                            <p className="text-uppercase fw-bold text-white-50 text-truncate mb-0 text-decoration-underline">
                              Total BOT
                            </p>
                          </div>
                        </div>
                        <div className="d-flex align-items-end justify-content-between mt-4">
                          <div>
                            <h4 className="fs-22 fw-bold ff-secondary mb-2 text-white">
                              <span>
                                <CountUp
                                  start={0}
                                  end={dashboardData.botCount}
                                  duration={2.5}
                                  separator=","
                                />
                              </span>
                            </h4>
                            <p className="text-white-50 mb-0">
                              Sales NRS.
                              <CountUp
                                start={0}
                                end={dashboardData.botSalesAmount}
                                duration={2.5}
                                separator=","
                                decimals={2}
                              />
                            </p>
                          </div>
                          <div className="avatar-sm flex-shrink-0">
                            <span
                              className={`avatar-title bg-white bg-opacity-10 rounded fs-3`}
                            >
                              <i
                                className={`text-white bx bx-shopping-bag`}
                              ></i>
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col lg={4} md={6} sm={12}>
                    <Card className="p-3 text-center shadow-lg rounded-3 border-top border-info">
                      <h3 className="text-info">{productData.categoryCount}</h3>
                      <p>Total Categories</p>
                    </Card>
                  </Col>
                  <Col lg={4} md={6} sm={12}>
                    <Card className="p-3 text-center shadow-lg rounded-3 border-top border-success">
                      <h3 className="text-success">
                        {productData.productCount}
                      </h3>
                      <p>Total Products</p>
                    </Card>
                  </Col>
                  <Col lg={4} md={6} sm={12}>
                    <Card className="p-3 text-center shadow-lg rounded-3 border-top border-primary">
                      <h3 className="text-primary">
                        {dashboardData.salesCount}
                      </h3>
                      <p>Total Orders</p>
                    </Card>
                  </Col>

                  <Col lg={6} md={6} sm={12}>
                    <Card
                      className="p-3 text-center shadow-lg rounded-3 border-top border-warning cursor-pointer"
                      onClick={toggleSellingProductModal}
                    >
                      <h3 className="text-warning">Best Selling Product</h3>
                    </Card>
                  </Col>
                  <Col lg={6} md={6} sm={12}>
                    <Card
                      className="p-3 text-center shadow-lg rounded-3 border-top border-danger cursor-pointer"
                      onClick={toggleModal}
                    >
                      <h3 className="text-danger">Top Customer</h3>
                    </Card>
                  </Col>
                </Row>

                <Row className="mt-4">
                  {/* <Col lg={6} md={12}>
                      <Card className="p-3 rounded-3 shadow-lg">
                        <ReactApexChart
                          options={barChartOptions}
                          series={barChartSeries}
                          type="bar"
                          height={350}
                        />
                      </Card>
                    </Col> */}
                  <Col lg={6} md={12}>
                    <PaymentDistributionChart paymentData={paymentData} />
                  </Col>
                </Row>
              </Row>
            )}
          </Row>
        </Container>
      </div>
      <TopCustomerModal
        isOpen={modalOpen}
        toggle={toggleModal}
        topCustomers={topCustomers}
      />
      <TopSellingProductModal
        isOpen={sellingProductModalOpen}
        toggle={toggleSellingProductModal}
        topProducts={productData}
      />
    </React.Fragment>
  );
}
